export function getAge(birthday: Date) {
  return new Date(+new Date - +birthday).getUTCFullYear() - 1970;
}
